module.exports = "/assets/b802a9203148d4f7b00386ee79870e41.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UX.png
// module id = 1907
// module chunks = 0